import Form from './form'
import Tags from './tags'

export {
    Form as CriteriaForm,
    Tags as CriteriaTags,
}


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/criteria/criteria.js